import { useEffect } from 'react';

// The charts library is large and used on one page only, so that page loads on demand
// (app/lazy-pages.tsx). The browser keeps the module, so preloading makes opening it instant.
export const loadChartsPage = () => import('../pages/charts');

/** Fetches the Charts page's code once the browser is idle, so opening it is usually instant. */
export function usePreloadPages(): void {
  useEffect(() => {
    const preload = () => {
      void loadChartsPage().catch(() => undefined);
    };
    if (typeof window.requestIdleCallback === 'function') {
      const handle = window.requestIdleCallback(preload, { timeout: 5_000 });
      return () => {
        window.cancelIdleCallback(handle);
      };
    }
    const timer = window.setTimeout(preload, 2_000);
    return () => {
      window.clearTimeout(timer);
    };
  }, []);
}
